// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"7ca71c4a","450":"8409967c","560":"ae27b609","773":"5257e560"}[chunkId] + ".js";
};